import * as types from '../mutation-types'

const state = {
    employers: '',
}
const getters = {
    // selectedEmployerId: state => state.employers.hiring_organization_id,
    // //getNoteId: state => state.employers.hiring_organization_id,
    // getNoteId: state => state.employers.noteable_id,

}
const actions = {
    // setEmployer({
    //     commit,
    //     state
    // }, data) {
    //     commit(types.SET_SELECTED_EMPLOYER, data);
    // }
}
const mutations = {
    // [types.SET_SELECTED_EMPLOYER](state, data) {
    //     state.employers = data;
    //     //console.log(state.employers);
    //     //console.log("NOTE", state.employers.hiring_organization.hiring_entities[0].id);
    // },

}
export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/employers.js